import { Reporte } from "../../components/Reporte"

export const ClienteRepPnBVG = () => {
    return (
        <Reporte url="reporte/buscar-pn-bvg" uindex="ficha/reporte-index-clientepn" nameReport="reporte-pn.xlsx" esBvg={true} />
    )
}
